// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.photos.RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption,
  RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyFloorPlanPhotoCaptionV2RequestDto,
  UserPropertyFloorPlanPhotoDeleteV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption_Args {
  postData: UserPropertyFloorPlanPhotoCaptionV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption_Args
>;

/**
 * Update caption of a floor plan photo
 */
export const useRentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption_Args) =>
      RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_caption(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete_Args {
  postData: UserPropertyFloorPlanPhotoDeleteV2RequestDto;
}

export type RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete_Args
>;

/**
 * Delete a photo of a floor plan
 */
export const useRentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyFloorPlanPhotoV2WebApiHandler_delete(args.postData, httpClient),
  });
};
